/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";

import * as styles from "./TestStyle.module.css";

type TestEnvVariablesDisplayProps = Readonly<{
  environmentVariables?: string[];
}>;

export const TestEnvVariablesDisplay = ({ environmentVariables }: TestEnvVariablesDisplayProps) => {
  if (!environmentVariables) {
    return null;
  }
  return (
    <div className={styles.crmDataDisplay}>
      <h3>Environment variables</h3>
      <div className={styles.crmDataListWrapper}>
        <div className={styles.forms}>
          {Object.entries(environmentVariables).map(([key, value], index) => (
            <div key={`envvar-${index}`}>
              <strong>{key}:</strong> {value}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
